import { handleAnalysisDone, handleAnalysisFailed } from "@/features/analysis";
import { handleBillingUpdated } from "@/features/billing";
import { handleDrillsReady } from "@/features/drills";
import { handleFriendsUpdated } from "@/features/friends";
import { handleHighlightsUpdated } from "@/features/highlights";
import { handleStatsUpdated } from "@/features/matches";
import { registerRealtimeHandler } from "@/shared/realtime";

// Обработчики, которые работают на любой странице, а не только пока открыт экран разбора:
// список матчей показывает статус разбора, поэтому окончание разбора (успех или падение)
// должно обновить его и на главной. Экран разбора вешает те же обработчики ещё раз
// (`useAnalysisEvents`) — это безвредно, они идемпотентны. Быстрый разбор новых матчей
// заканчивается в фоне — `stats.updated` обновляет сводку и оценки, где бы игрок ни был.
// Друзья из Steam тоже грузятся в фоне — `friends.updated` перечитывает экран «Друзья».
// Задачи тренировки строятся после разбора — `drills.ready` обновляет значок меню и главную.
// Оплата подтверждается в фоне — `billing.updated` обновляет статус Pro и окно оплаты.
// Хайлайты ищутся и клипы пишутся в фоне — `highlights.updated` обновляет их где угодно.
export const registerAppRealtimeHandlers = (): (() => void) => {
  const unregister = [
    registerRealtimeHandler("analysis.done", handleAnalysisDone),
    registerRealtimeHandler("analysis.failed", handleAnalysisFailed),
    registerRealtimeHandler("stats.updated", handleStatsUpdated),
    registerRealtimeHandler("friends.updated", handleFriendsUpdated),
    registerRealtimeHandler("drills.ready", handleDrillsReady),
    registerRealtimeHandler("billing.updated", handleBillingUpdated),
    registerRealtimeHandler("highlights.updated", handleHighlightsUpdated),
  ];
  return () => {
    unregister.forEach((off) => {
      off();
    });
  };
};
